import { Box } from "@chakra-ui/react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../Context/AuthProvider";
import { getPowerBIToken } from "../../../utils/powerBIUtils";

const PowerBi = ({ powerBiData }) => {
  const [embedConfig, setEmbedConfig] = useState(null);
  const { userData } = useContext(AuthContext);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const mountOnce = async () => {
      const email = userData?.userDetails;
      const powerBIToken = await getPowerBIToken(email);
      const embedUrl = powerBiData.embedURL;

      const cfg = {
        type: "report",
        embedUrl: embedUrl,
        tokenType: models.TokenType.Aad,
        accessToken: powerBIToken,
      };
      setEmbedConfig(cfg);
    };

    mountOnce();
  }, [powerBiData.embedURL, userData?.userDetails]);

  return (
    <Box as="div" maxH="82vh" h="82vh" overflow="hidden" pt={5}>
      {embedConfig && (
        <PowerBIEmbed
          embedConfig={embedConfig}
          cssClassName={"report-container"}
        />
      )}
    </Box>
  );
};

export default PowerBi;
